var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDustSoso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M459.281 112C267.487 112 112 273.177 112 472L112 552C112 750.823 267.487 912 459.281 912L564.719 912C756.513 912 912 750.823 912 552L912 472C912 273.177 756.513 112 564.719 112L459.281 112ZM463.219 142L560.781 142C738.191 142 882 291.089 882 475L882 549C882 732.911 738.191 882 560.781 882L463.219 882C285.809 882 142 732.911 142 549L142 475C142 291.089 285.809 142 463.219 142Z",
    fill: "#00ef6f",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.922 613.05C404.605 751.141 624.39 756.761 649.046 613.939",
    fill: "none",
    opacity: 1,
    stroke: "#00ef6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.093 349.024L379.854 349.024C418.303 349.024 449.473 380.194 449.473 418.644L449.473 439.405C449.473 477.855 418.303 509.024 379.854 509.024L359.093 509.024C320.643 509.024 289.473 477.855 289.473 439.405L289.473 418.644C289.473 380.194 320.643 349.024 359.093 349.024Z",
    fill: "#00ef6f",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.345 343.342L665.106 343.342C703.556 343.342 734.725 374.512 734.725 412.962L734.725 433.723C734.725 472.173 703.556 503.342 665.106 503.342L644.345 503.342C605.895 503.342 574.725 472.173 574.725 433.723L574.725 412.962C574.725 374.512 605.895 343.342 644.345 343.342Z",
    fill: "#00ef6f",
    opacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustSoso);
export default __webpack_public_path__ + "static/media/DustSoso.4407f9ce1bcefe8a4af37f9c81a8e37c.svg";
export { ForwardRef as ReactComponent };